import { rest } from 'msw';

import { getConfig } from 'shared/config';

import { agreementCreditCardNetsEasy, agreementMobilePay, agreements, pendingAgreement } from '.';

const paymentAPI = `${getConfig().microServices?.host}/payment/gateway`;

export const handlers = [
  rest.get(`${paymentAPI}/my/agreements`, (req, res, ctx) => res(ctx.json(agreements))),
  rest.get(`${paymentAPI}/accounts/:agreementId/agreement/external/pending`, (req, res, ctx) =>
    res(ctx.json(pendingAgreement)),
  ),
  rest.post(`${paymentAPI}/accounts/:accountId/agreements/creditcard`, (req, res, ctx) =>
    res(ctx.json(agreementCreditCardNetsEasy)),
  ),
  rest.post(`${paymentAPI}/accounts/:accountId/agreements/directdebit`, (req, res, ctx) =>
    res(ctx.json({})),
  ),
  rest.post(`${paymentAPI}/accounts/:accountId/agreements/mobilepay`, (req, res, ctx) =>
    res(ctx.json(agreementMobilePay)),
  ),
];
